import { types } from "../types/types";

const initialState = {
  loading: false,
  preview: null,
  executeResult: null
};

export const flowReassignmentReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case types.FLOW_REASSIGNMENT_START_LOADING:
      return { ...state, loading: action.payload };
    case types.FLOW_REASSIGNMENT_SET_PREVIEW:
      return { ...state, preview: action.payload, executeResult: null };
    case types.FLOW_REASSIGNMENT_SET_EXECUTE_RESULT:
      return { ...state, executeResult: action.payload };
    case types.FLOW_REASSIGNMENT_CLEAR:
      return { ...initialState };
    default:
      return state;
  }
};
